import { render, staticRenderFns } from "./inspePlanAdd.vue?vue&type=template&id=956cb8fa&scoped=true"
import script from "./inspePlanAdd.vue?vue&type=script&lang=js"
export * from "./inspePlanAdd.vue?vue&type=script&lang=js"
import style0 from "./inspePlanAdd.vue?vue&type=style&index=0&id=956cb8fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956cb8fa",
  null
  
)

export default component.exports